export default class ReleaseNoteDetail {
    constructor() { }
    static fromApi(data) {
        if (Array.isArray(data)) {
            return data.map((et) => ReleaseNoteDetail.define(et));
        }
        else if (data != null) {
            return ReleaseNoteDetail.define(data);
        }
        else
            return null;
    }
    static define(data) {
        let releaseNoteDetail = new ReleaseNoteDetail();
        releaseNoteDetail.id = data.id;
        releaseNoteDetail.title = data.title?.rendered;
        releaseNoteDetail.link = data.link;
        releaseNoteDetail.content = data.content?.rendered;
        releaseNoteDetail.content = releaseNoteDetail.content.replaceAll('<a href="https://www.loghub.sk/blog/">&lt; Späť na články</a>', '');
        return releaseNoteDetail;
    }
}
